import styled from "styled-components"

export const StyledUserPanelManageContracts = styled.section`
    width: 100%;
    height: 100%;
`